import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {RecordPageVO, useQueryRecordPage} from "@/service/record.s";
import {Avatar} from "@mui/material";
import {ViewRecord} from "@/pages/Record/ViewRecord";
import {RecordForm} from "@/widget/RecordForm/RecordForm";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

export const RecordListPage = () => {
    const {
        mutate: recordPageMutate,
        data: recordPageData,
        isPending: recordPagePending,
    } = useQueryRecordPage()

    const columns: GridColDef<RecordPageVO>[] = [
        {
            field: "content",
            headerName: "记录内容",

            minWidth: 120,
            flex: 0.6
        },
        {
            field: "way",
            headerName: "跟进方式",
            flex: 0.3,
            renderCell: ({row}) => <Chip color={'info'} label={row.way} size={'small'} variant={'outlined'}/>
        },
        {
            field: "type",
            headerName: "跟进内容",
            flex: 0.3,
            display: 'flex',
            renderCell: ({row}) => <Typography color={'warning'}>{row.type}</Typography>
        },
        {
            field: "customerName", headerName: "客户名称", align: 'center', headerAlign: 'center', minWidth: 150, flex: 0.6,
            valueFormatter: value => value || "-"
        },
        {
            field: "creator",
            headerName: "跟进人",
            headerAlign: "center",
            align: "center",
            display: 'flex',
            renderCell: ({row}) => <Avatar {...stringAvatar(row.creator)} />
        },
        {
            field: "createdAt",
            headerName: "跟进时间",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    return (
        <ProTable<RecordPageVO>
            loading={recordPagePending}
            renderDrawer={{
                view: <ViewRecord/>, write: <RecordForm mode={'drawer'}/>
            }}
            columns={columns}
            data={recordPageData?.data}
            onSearch={(params) => {
                recordPageMutate(params);
            }}
            code={"record"}
        />
    );
};
